module.exports = __webpack_public_path__ + "static/media/app-bar-save.5b3b467a.svg";